export default __webpack_public_path__ + "static/media/consumer-void-transaction.411928a0.png";